<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<label for="documentsType" class="mt-3">Typ</label>
						<ng-select
							id="documentsType"
							name="documentsType"
							[(ngModel)]="filters.documentTypeId"
							[multiple]="true"
							[closeOnSelect]="false"
							bindLabel="name"
						>
							<ng-option *ngFor="let item of vehicleDocumentsTypes" [value]="item.id">{{
								item.type
							}}</ng-option>
						</ng-select>
						<!-- <label class="form-label mt-3">Data ważności (Dowód rejestracyjny)</label>
						<div class="col">
							<input type="date" class="form-control" name="filters.date_from" id="date_from">
						</div> -->
						<label for="type" class="mt-3">Typ pojazdu</label>
						<ng-select
							id="type"
							name="type"
							[(ngModel)]="filters.types"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of types" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
						<label for="statuses" class="mt-3">Status pojazdu</label>
						<ng-select
							id="statuses"
							name="statuses"
							[(ngModel)]="filters.statuses"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of statuses" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
